import React, { useState, useEffect } from 'react';

interface RateLineProps {
  text: string;
  subText?: string;
  price: string;
  textColor?: string;
  subTextColor?: string;
  priceColor?: string;
  borderColor?: string;
}

function RateLine({
  text,
  subText,
  price,
  textColor = '#003DA5',
  subTextColor = '#00AEEF',
  priceColor = '#003DA5',
  borderColor = '#00AEEF',
}: RateLineProps) {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    setIsAnimating(true);
    const timeout = setTimeout(() => setIsAnimating(false), 500);
    return () => clearTimeout(timeout);
  }, [price]);

  return (
    <div
      className="flex justify-between border-b-[4px] py-[1vh]"
      style={{ borderColor }}
    >
      <div
        className={`flex flex-col justify-center ${subText ? 'max-w-[60%]' : ''}`}
      >
        <p
          className="text-[4.5vw] font-bold leading-tight"
          style={{ color: textColor }}
        >
          {text}
        </p>
        {subText && (
          <p
            className="text-[3.5vw] font-bold leading-tight"
            style={{ color: subTextColor }}
          >
            {subText}
          </p>
        )}
      </div>
      <div className="flex flex-col justify-center">
        <p
          className={`text-[5vw] font-extrabold leading-tight transition-all duration-300 ${
            isAnimating ? 'scale-110 opacity-80' : 'scale-100 opacity-100'
          }`}
          style={{ color: priceColor }}
        >
          {price}
        </p>
      </div>
    </div>
  );
}

export default RateLine;
